interface TabSegmentProps {
  tabIndex: number;
  segments: string[];
  onTabChange: (index: number) => void;
  className?: string;
}

const TabLineFill = ({ tabIndex, segments, onTabChange, className = '' }: TabSegmentProps) => {
  return (
    <div
      className={`w-full h-full flex items-stretch bg-transparent px-[16px] border-b border-surface-lv2 ${className}`}
    >
      {segments.map((segment, index) => (
        <button
          key={`tab-segment-${segment}`}
          type="button"
          onClick={() => onTabChange(index)}
          className={`flex-1 h-full text-[16px] text-center bg-transparent leading-none transition-colors ${
            index === tabIndex
              ? 'font-bold text-primary-light dark:text-primary-dark shadow-[inset_0_-3px_0_0_#5C3DFA]'
              : 'text-text-main-lv4'
          }`}
        >
          {segment}
        </button>
      ))}
    </div>
  );
};

export default TabLineFill;
